import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameManager} from '../UIGameManager'
import {UICityHoverActionController} from '../ui_game_hover_actions/UICityHoverActionController'
import {UIRoadHoverActionController} from '../ui_game_hover_actions/UIRoadHoverActionController'
import {UISettlementHoverActionController} from '../ui_game_hover_actions/UISettlementHoverActionController'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {MechanicCityState, MechanicRoadState, MechanicSettlementState} from '@colonist/game-states'

export enum UIGameActionButtonPositions {
    Trade,
    DevCard,
    CityImprovementMultiButtonMobile,
    CityWall,
    Road,
    Settlement,
    City,
    EndTurn,
    BuildShip,
    MoveShip,
    KnightMultiButton,
    CityImprovementMultiButtonWeb
}

export class UIGameActionsController {
    protected readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager, settlementState: MechanicSettlementState | undefined, cityState: MechanicCityState | undefined, roadState: MechanicRoadState | undefined) {
        this.uiGameManager = uiGameManager

        if(this.uiGameManager.gameController.isPlayerSpectator) return
        if(this.uiGameManager.gameController.isReplay) return

        this.initializeHoverActions(settlementState, cityState, roadState)
    }

    private initializeHoverActions(settlementState: MechanicSettlementState | undefined, cityState: MechanicCityState | undefined, roadState: MechanicRoadState | undefined): void {
        if(roadState) new UIRoadHoverActionController(this.uiGameManager, roadState)
        if(settlementState) new UISettlementHoverActionController(this.uiGameManager, settlementState)
        if(cityState) new UICityHoverActionController(this.uiGameManager, cityState)
    }
}
